import React from 'react'
import { connect } from 'react-redux'
import SiteLayout from '../../containers/layout/SiteLayout'
import HelmetTitle from '../../components/layout/HelmetTitle'
import { unsetPreviewMode } from '../../actions/AuthActions'

class SetPreviewMode extends React.Component {

  componentDidMount() {
    const { props } = this
    const { dispatch } = props
    dispatch(unsetPreviewMode())
    localStorage.removeItem('previewMode')
  }

  componentDidUpdate() {
  }

  renderBody = (props,state) => <SiteLayout>
    <HelmetTitle title={'Unset Preview Mode'} />
    <div style={{ backgroundColor: 'white', padding: 10, paddingBottom: 20, borderColor: 'black', borderWidth: 1, borderStyle: 'solid' }} >
      Preview mode unset
    </div>
  </SiteLayout>

  render = () => this.renderBody(this.props,this.state)

}

export default connect(
  (store, props) => {}
)(SetPreviewMode)
